document.addEventListener('DOMContentLoaded', function () {

  // placeholder
  setPlaceHolder();
  // inputChange
  if($('.js-inputChange').length > 0) inputChange($('.js-inputChange'));
  // ページ戻り時
  $(window).on('popstate', function(){
    $('#confirm-overlay').empty()
    $('body').removeClass('overflow')
  });



  // form id name
  const form_id = '#contactForm';

  // Rules
  const rules = {
    lastName: {
      required: true
    },
    firstName: {
      required: true
    },
    company: {
      required: true
    },
    zip: {
      required: false,
      number: true,
      minlength: 7,
      maxlength: 7
    },
    region: {
      required: false
    },
    locality: {
      required: false
    },
    tel: {
      required: true,
      tel: true,
      number: true,
    },
    mail: {
      required: true,
      halfchara: true,
      mail: true
    },
    inquiry: {
      required: true
    },
    contact: {
      required: true
    },
    privacy: {
      required: true
    }
  } // rules

  const messages = {
    lastName: {
      required: '入力してください'
    },
    firstName: {
      required: '入力してください'
    },
    company: {
      required: '入力してください'
    },
    zip: {
      required: '入力してください',
      number: '半角数字で入力してください',
      minlength: '正しい郵便番号を入力してください',
      maxlength: '正しい郵便番号を入力してください'
    },
    region: {
      required: '入力してください'
    },
    locality: {
      required: '入力してください'
    },
    tel: {
      required: '入力してください',
      tel: '正しい電話番号を入力してください',
      number: '半角数字で入力してください',
    },
    mail: {
      required: '入力してください',
      halfchara: '半角英数字で入力してください',
      mail: '正しいメールアドレスを入力してください'
    },
    inquiry: {
      required: '入力してください'
    },
    contact: {
      required: '選択してください'
    },
    privacy: {
      required: 'チェックしてください'
    }
  }

  // 追加ルールの定義
  const methods = {
    halfchara: function halfchara( value, element ){
      return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
    },
    number: function number( value, element ){
      return this.optional(element) || /^([0-9]+)$/.test(value);
    },
    tel: function tel( value, element ) {
      // 電話番号のバリデーション
      return this.optional(element) || /^\d{10,11}$/.test(value);
    },
    mail: function mail( value, element ) {
      // メールアドレスのバリデーション
      return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    }
  }
  // メソッドの追加（上記の追加ルールを適用させる）
  $.each( methods, function( key ) {
    $.validator.addMethod( key, this );
  })

  // jQuery Validation Plugin の初期化
  $( form_id ).validate({
    rules    : rules,
    messages : messages,
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element ){
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element ){
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' );
      error.prependTo( eleName + '_error' );
      //console.log(error);
      //messageElm.innerHTML = error;
    },
    // submit
    submitHandler: function(form){
      const fd = $(form).serialize();
      confirmHandler( './comfirm.php', fd, form );
    }
  });

});
